import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { MobileDefaultTheme, DesktopDefaultTheme } from ".";


export default /*@__PURE__*/_defineComponent({
  __name: 'default',
  props: {
    menuActive: {},
    accountStatus: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const menuList = computed(() => {
  if (props.accountStatus === "ACTIVE") {
    return [
      {
        key: "accounts",
        icon: "change",
        label: t("common.labels.change_account"),
        url: "/accounts",
      },
      {
        key: "signs",
        icon: "card-2",
        label: t("common.labels.signs"),
        url: "/signs",
      },
    ];
  }

  return [
    {
      key: "accounts",
      icon: "change",
      label: t("common.labels.change_account"),
      url: "/accounts",
    },
    {
      key: "plans",
      icon: "plans",
      label: t("common.labels.plans"),
      url: "/plans",
    },
  ];
});

return (_ctx: any,_cache: any) => {
  return (_ctx.$store.getters.mobile)
    ? (_openBlock(), _createBlock(_unref(MobileDefaultTheme), {
        key: 0,
        "menu-list": menuList.value
      }, {
        main: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["menu-list"]))
    : (_openBlock(), _createBlock(_unref(DesktopDefaultTheme), {
        key: 1,
        "menu-list": menuList.value,
        "menu-active": __props.menuActive
      }, {
        main: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["menu-list", "menu-active"]))
}
}

})